import { render, staticRenderFns } from "./CheckoutDetail.vue?vue&type=template&id=23628e90&"
import script from "./CheckoutDetail.vue?vue&type=script&lang=js&"
export * from "./CheckoutDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports